// Need to use the React-specific entry point to allow generating React hooks
import { createApi } from '@reduxjs/toolkit/query/react'
import { getQueryDefaultParams } from 'src/utils/query'
import { updateAllGarmentsForType } from '../slices/databaseSlice'
import { baseQuery } from './queries'

const GARMENTS_ENDPOINT = `/garments`
const GARMENT_ENDPOINT = `/garment/`

// API used for the Garment ressource
export const apiGarment = createApi({
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getGarments: builder.mutation<API.Resp.GetGarments, API.Req.GetGarments>({
            query: (input) => ({
                url: `${GARMENTS_ENDPOINT}`,
                params: { ...input, ...getQueryDefaultParams() },
            }),
            async onCacheEntryAdded(
                arg,
                { dispatch, cacheEntryRemoved, cacheDataLoaded, getCacheEntry }
            ) {
                try {
                    // wait for the initial query to resolve before proceeding
                    await cacheDataLoaded

                    const cacheEntryAfterLoad = getCacheEntry()
                    const data = cacheEntryAfterLoad.data
                    const garmentType = arg.type
                    const filterGarmentId = arg.garment_id
                    dispatch(
                        updateAllGarmentsForType({
                            type: garmentType,
                            garments: data,
                            filterGarmentId,
                        })
                    )
                } catch {
                    // no-op in case `cacheEntryRemoved` resolves before `cacheDataLoaded`,
                    // in which case `cacheDataLoaded` will throw
                }
                // cacheEntryRemoved will resolve when the cache subscription is no longer active
                await cacheEntryRemoved
                // perform cleanup steps once the `cacheEntryRemoved` promise resolves
            },
        }),
        getGarmentDetail: builder.query<API.Resp.GetGarmentDetail, API.Req.GetGarmentDetail>({
            query: (input) => ({
                url: `${GARMENT_ENDPOINT}${input.id}`,
                params: getQueryDefaultParams(),
            }),
        }),
    }),
    reducerPath: 'apiGarment',
})

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const { useGetGarmentsMutation, useGetGarmentDetailQuery } = apiGarment
